import React from 'react'
import { Link } from 'react-router-dom'
import PT from 'prop-types'

const Sipecka = ({ to }) => (
  <Link className="sipecka" to={to}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35.47 21.827"><path d="M0,13.1V8.731H27.466l-6.366-6L24.556,0,35.47,10.914,24.556,21.827,21.1,18.917,27.466,13.1Z" /></svg>
  </Link>
)

Sipecka.propTypes = {
  to: PT.string.isRequired,
}

export default Sipecka



// WEBPACK FOOTER //
// ./src/components/Post/Sipecka.js